import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=6c1b6ff4&scoped=true&"
import script from "./EmailList.vue?vue&type=script&lang=js&"
export * from "./EmailList.vue?vue&type=script&lang=js&"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=6c1b6ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b6ff4",
  null
  
)

export default component.exports